export const widgetKeys = {
  all: ['widget'] as const,
  chats: () => [...widgetKeys.all, 'chat'] as const,
  chat: (chatId?: string) => [...widgetKeys.chats(), chatId] as const,
  history: (organizationId?: string, userToken?: string | null) =>
    [...widgetKeys.all, 'history', organizationId, userToken] as const
};
